<div class="width100 footer pad-left">
   <ul>
      <div class="row2 landscape-mode">
        <li class="link"><a href="http://www.dbs.com/terms/default.page" target="_blank">Terms &amp; Conditions</a></li>
        <li class="separator">|</li>
        <li class="link"><a href="http://www.dbs.com/privacy/default.page" target="_blank">Privacy Policy</a><span></span></li>
        <li class="separator">|</li>
        <li class="link"><a href="http://www.dbs.com/fairdealing/default.page" target="_blank">Fair Dealing Commitment</a><span></span></li>
        <li class="separator">|</li>
        <li class="link"><a href="http://www.dbs.com.sg/personal/compliance-tax-requirements/index.html" target="_blank">Compliance with Tax Requirements</a><span> </span> </li>
        <li class="separator">|</li>
        <li class="link"><a href="http://www.dbs.com.sg/personal/default.page?pid=sg-dbs-ib-login-txtlink-dbsbank" target="_blank">©2020 DBS Bank Ltd</a><span></span></li>
        <li class="separator">|</li>
        <li class="link"><a href="http://www.dbs.com.sg/personal/default.page?pid=sg-dbs-ib-login-txtlink-dbsbank" target="_blank">Co. Reg. No. 196800306E</a></li>
      </div>
      <div class="row2 portrait-mode">
        <div class="nobreak">
          <li class="link"><a href="http://www.dbs.com/terms/default.page" target="_blank">Terms &amp; Conditions</a></li>
          <li class="separator">|</li>
          <li class="link"><a href="http://www.dbs.com/privacy/default.page" target="_blank">Privacy Policy</a><span></span></li>
          <li class="separator">|</li>
          <li class="link"><a href="http://www.dbs.com/fairdealing/default.page" target="_blank">Fair Dealing Commitment</a><span></span></li>
          <li class="separator">|</li><br/>
        </div>
        <div class="nobreak">
          <li class="link pad-right-more"><a href="http://www.dbs.com.sg/personal/compliance-tax-requirements/index.html" target="_blank">Compliance with Tax Requirements&nbsp; &nbsp;</a><span></span></li>
          <li class="separator">|&nbsp;</li>
          <li class="link"><a href="http://www.dbs.com.sg/personal/default.page?pid=sg-dbs-ib-login-txtlink-dbsbank" target="_blank">©2020 DBS Bank Ltd&nbsp; &nbsp;&nbsp; &nbsp;</a><span></span></li>
          <li class="separator">|</li><br/>
        </div>
        <div class="nobreak">
          <li class="link"><a href="http://www.dbs.com.sg/personal/default.page?pid=sg-dbs-ib-login-txtlink-dbsbank" target="_blank">Co. Reg. No. 196800306E</a></li>
        </div>
      </div>
   </ul>
   <br/><br/>
</div>
